'use strict';

var React = require('react');

var SvgCreditCardCancelMajor = function SvgCreditCardCancelMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 9.9a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9Zm-1.29 2.415a.562.562 0 1 0-.795.796l1.29 1.29-1.29 1.29a.562.562 0 1 0 .795.795l1.29-1.29 1.29 1.29a.563.563 0 0 0 .795-.796l-1.29-1.29 1.29-1.29a.562.562 0 1 0-.795-.795l-1.29 1.29-1.29-1.29Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 0a1.5 1.5 0 0 0-1.5 1.5v1.5h20v-1.5a1.5 1.5 0 0 0-1.5-1.5h-17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12.5v-7.5h20v3h-6c-2.757 0-5 2.236-5 4.987v1.013h-7.5a1.5 1.5 0 0 1-1.5-1.5Zm2-3.5h5v-2h-5v2Z",
    fillRule: "evenodd"
  }));
};

exports.SvgCreditCardCancelMajor = SvgCreditCardCancelMajor;
